import { Spinner } from '@/components/basic/Loading'
import { cn } from '@/modules/classnames'
import { Button, Title3, makeStyles } from '@fluentui/react-components'
import { ChevronCircleLeftFilled, ChevronCircleRightFilled } from '@fluentui/react-icons'
import type { FC, ReactNode } from 'react'
import { FullCalendarRef, View } from './PMCalendar.Common'

interface IHeaderProps {
  title: string
  view: View
  FCRef: FullCalendarRef
  updateViewData: () => void
  buttonsLeft?: ReactNode
  buttonsRight?: ReactNode
  loading?: boolean
}

const useHeaderStyles = makeStyles({
  button: {
    minWidth: '50px',
  },
})

export const Header: FC<IHeaderProps> = ({
  title,
  FCRef,
  updateViewData,
  view,
  buttonsLeft,
  buttonsRight,
  loading,
}) => {
  const classes = useHeaderStyles()
  const afterClickWrapper = (f: () => void) => () => {
    f()
    updateViewData()
  }
  const buttonAppearance = (buttonView: View) => (view === buttonView ? 'primary' : 'secondary')
  return (
    <div className="hide-on-print box-border flex w-full flex-row justify-between p-2">
      <div className="items-start">
        <Button icon={<ChevronCircleLeftFilled />} onClick={afterClickWrapper(() => FCRef.current?.getApi().prev())} />
        <Button icon={<ChevronCircleRightFilled />} onClick={afterClickWrapper(() => FCRef.current?.getApi().next())} />
        <Button className={classes.button} onClick={afterClickWrapper(() => FCRef.current?.getApi().today())}>
          {'today'}
        </Button>
        {buttonsLeft}
      </div>
      <div className="flex flex-row items-center">
        <Spinner size="extra-small" className={cn('mr-4', { 'opacity-0': !loading })} />
        <Title3>{title}</Title3>
      </div>
      <div className="items-end">
        {buttonsRight}
        <Button
          className={classes.button}
          onClick={afterClickWrapper(() => FCRef.current?.getApi().changeView(View.Month))}
          appearance={buttonAppearance(View.Month)}
        >
          {'month'}
        </Button>
        <Button
          className={classes.button}
          onClick={afterClickWrapper(() => FCRef.current?.getApi().changeView(View.Week))}
          appearance={buttonAppearance(View.Week)}
        >
          {'week'}
        </Button>
        <Button
          className={classes.button}
          onClick={afterClickWrapper(() => FCRef.current?.getApi().changeView(View.Day))}
          appearance={buttonAppearance(View.Day)}
        >
          {'day'}
        </Button>
      </div>{' '}
    </div>
  )
}
